export enum UserStatus {
    OK = 'ok',
    NOT_OK = 'not_ok',
    BLOCKED = 'blocked'
}

export interface UserStatusMeta {
    friendlyName: string;
    severity: string;
    color: string;
    backgroundColor: string;
    borderColor: string;
}

export const UserStatusMeta: Record<UserStatus, UserStatusMeta> = {
    [UserStatus.OK]: {
        friendlyName: 'Ok',
        severity: 'success',
        color: '#059669',
        backgroundColor: '#ecfdf5',
        borderColor: '#d1fae5'
    },
    [UserStatus.NOT_OK]: {
        friendlyName: 'Not Ok',
        severity: 'info',
        color: '#6b7280',
        backgroundColor: '#f9fafb',
        borderColor: '#e5e7eb'
    },
    [UserStatus.BLOCKED]: {
        friendlyName: 'Blocked',
        severity: 'danger',
        color: '#dc2626',
        backgroundColor: '#fef2f2',
        borderColor: '#fecaca'
    }
};

export interface IUser {
    agent: {
        name: string;
        id: number;
    };
    agentLink: string;
    createdBy: string;
    createdDate: string;
    department: string;
    editable: boolean;
    email: string;
    jobTitle: string;
    language: string;
    mobilePhone: string;
    modifiedBy: string;
    modifiedDate: string;
    name: string;
    passwordChangeable: boolean;
    passwordExpiry: string;
    roles: [
        {
            id: number;
            code: string;
            explation: string;
        }
    ];
    status: string;
    userId: number;
    userName: string;
    workPhone: string;
}

export interface IModalInformation {
    statuses: string[];
    roles: { id: number; code: string; explation: string }[];
    agents: { id: number; name: string }[];
}

export interface IUserCreateRequest {
    agentId: number;
    department: string;
    email: string;
    jobTitle: string;
    userName: string;
    workPhone: string;
    mobilePhone: string;
    name: string;
    roles: number[];
    status: string;
    language: string;
    password: string;
}
export interface IUserEditRequest {
    agentId: number;
    department: string;
    email: string;
    jobTitle: string;
    userName: string;
    workPhone: string;
    mobilePhone: string;
    name: string;
    roles: number[];
    status: string;
    userId: number;
    language: string;
    oldPassword?: string;
    newPassword?: string;
}
